import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { TessellateModifier } from "three/examples/jsm/modifiers/TessellateModifier.js";
import { applyCustomMaterials } from "./materials/apply-custom-materials.js";
import { fitShadowCameraToScene } from "./fit-shadow-camera.js";

/**
 * @typedef {object} WorldRuntime
 * @property {import("three").Group} root
 * @property {import("three").Camera | null} camera
 * @property {import("three").Object3D | null} cameraTarget
 * @property {import("three").Object3D | null} centerWaves
 * @property {import("three").Mesh | null} movingLiquid
 */

export async function loadWorld({
  url,
  scene,
  keyLight,
  materials,
  waveUniforms,
  viewport,
}) {
  const loader = new GLTFLoader();
  const gltf = await loader.loadAsync(url);
  const root = gltf.scene;

  applyCustomMaterials(root, materials);

  const centerWaves = root.getObjectByName("centerWaves") ?? null;
  const movingLiquid =
    root.getObjectByName("FluessigbodenPlane_moving") ?? null;

  if (!centerWaves) {
    console.warn("[Waves] Missing centerWaves empty in GLTF scene.");
  }

  if (!movingLiquid) {
    console.warn(
      "[Waves] Missing FluessigbodenPlane_moving mesh in GLTF scene.",
    );
  } else {
    const tessellate = new TessellateModifier(0.12, 6);
    movingLiquid.geometry = tessellate.modify(movingLiquid.geometry);
    movingLiquid.geometry.computeVertexNormals();
    movingLiquid.geometry.computeBoundingBox();

    const { min, max } = movingLiquid.geometry.boundingBox;
    waveUniforms.bounds.value.set(min.x, max.x, min.z, max.z);
  }

  scene.add(root);
  scene.add(keyLight.target);
  fitShadowCameraToScene(keyLight, root);

  const camera = gltf.cameras[0] ?? null;
  if (camera) {
    camera.aspect = viewport.width / viewport.height;
    camera.updateProjectionMatrix();
    scene.add(camera);
  } else {
    console.warn("No cameras found in the GLTF model.");
  }

  const cameraTarget = root.getObjectByName("cameraTarget") ?? null;
  if (cameraTarget) cameraTarget.visible = false;

  return {
    root,
    camera,
    cameraTarget,
    centerWaves,
    movingLiquid,
  };
}
